import { http } from "@/core/api/";

const apiUrl = "api/student/visualimpairments";

export const getVisualImpairmentsAcademicYears = async () =>
  await http.get(`${apiUrl}/academicyears`);

export const getVisualImpairments = async params =>
  await http.get(`${apiUrl}/search`, { params });

export const getQuestionAnswers = async () =>
  await http.get(`${apiUrl}/questionanswers`);

export const getSchoolgrade = async () =>
  await http.get(`${apiUrl}/schoolgrade`);
export const getVisualImpairmentDetails = async id =>
  await http.get(`${apiUrl}/${id}`);

export const saveVisualImpairment = async (id, payload) =>
  await http.post(`${apiUrl}/${id}/save`, payload, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });

export const changeStatus = async payload =>
  await http.post(`${apiUrl}/changestatus`, payload);
